"use strict";exports.__esModule=true;exports.default=void 0;var _default={"-":"",_:" ",0:"0"};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/time-converter/pads.js
// module id = /s6c
// module chunks = 5